import PropTypes from 'prop-types';
import { FaRegCheckCircle } from 'react-icons/fa';
import { HotelProviders, HotelProvidersLabels } from '../../../../../constants';

const HotelProviderLabel = ({ itinerary }) => {
  const provider = itinerary?.hotel?.priceProvider;
  const doShowProviderLabel = provider === HotelProviders.TABLET;

  return doShowProviderLabel ? (
    <div className="text-sm -mt-1 bg-theme bg-opacity-10 p-2 rounded-md" style={{ width: 'max-content' }}>
      <div className="text-green-600 text-preferenceLabelColor-0 font-bold mr-3">
        <FaRegCheckCircle className="inline -mt-1" />
        {' '}
        <span>
          {HotelProvidersLabels[provider] || provider}
          {' '}
          Hotel
        </span>
      </div>
    </div>
  ) : <></>;
};

HotelProviderLabel.propTypes = {
  itinerary: PropTypes.shape().isRequired,
};

export default HotelProviderLabel;
